<template>
  <form action="https://test.payu.in/_payment" method="post">
    <div v-if="payData">
      <input type="hidden" name="firstname" :value="payData.firstName" />
      <input type="hidden" name="lastname" :value="payData.lastName" />
      <input
        type="hidden"
        name="surl"
        value="http://202.46.201.50:1126/login"
      />
      <input type="hidden" name="phone" :value="payData.phone" />
      <input type="hidden" name="key" :value="payData.key" />
      <input type="hidden" name="hash" :value="payData.hashData" />
      {{ payData.txnID }}
      <input type="hidden" name="curl" value="http://www.google.com" />
      <input type="hidden" name="furl" value="https:/www.yahoo.in" />
      <input type="hidden" name="txnid" :value="payData.txnID" />
      <input type="hidden" name="productinfo" :value="payData.productInfo" />
      <input type="hidden" name="amount" :value="payData.strAmount" />
      <input type="hidden" name="email" :value="payData.email" />
    </div>
    <input type="submit" value="submit" />
  </form>
</template>

<script>
import axios from "axios";
import { get } from "vuex-pathify";

import { showSnackbar } from "../util/globalActions";

export default {
  name: "PaymentGate",

  data: () => ({
    reqRules: [(v) => !!v || "Field is required"],
    validEdit: false,
    permission: {
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isDownload: false,
    },
    genders: [
      {
        text: "Male",
        value: "M",
      },
      {
        text: "Female",
        value: "F",
      },
    ],
    saveLoading: false,
    BIRTH_DT: "",
    message: "",
    snackbar: false,
    length: 4,
    tab: null,
  }),
  created() {this.DuePay();},
  mounted() {
    

    
  },
  computed: {
    apiUrl: get("app/apiUrl"),
  },
  watch: {},
  methods: {
    editItem() {},

    DuePay() {
      const self = this;
      axios({
        url: self.apiUrl + "api/Fees/InitPayment",
        method: "POST",
        data: { uTR8_DuePay: this.selected },
        responseType: "json",
      })
        .then(function(res) {
          self.payData = res.data;
          console.log(self.payData);
          document.getElementById("btnOK").click();
          //self.$refs.myBtn.click();
          showSnackbar({ message: "found!" });
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
  },
  beforeDestroy() {},
};
</script>
